import React from 'react';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
import { calculateTrendFromComparison } from 'src/utils/calculateTrendFromTimeSeries';

type OptimizationMetricCardProps = {
  optimizedValue: number;
  initialValue: number;
  name: string;
  icon: React.ReactNode;
  // Monetary values render with the customer currency (see KeyMetricCard)
  isEuro?: boolean;
};

const trendTooltip =
  'Shows how much the optimized value has increased or decreased compared to the initial value.';

export const OptimizationMetricCard: React.FC<OptimizationMetricCardProps> = ({
  optimizedValue,
  initialValue,
  name,
  icon,
  isEuro = false,
}) => {
  const { trend, trendValue } = calculateTrendFromComparison(
    optimizedValue,
    initialValue,
  );

  return (
    <KeyMetricCard
      title={name}
      isEuro={isEuro}
      value={optimizedValue}
      trend={trend}
      trendValue={trendValue}
      trendTooltip={trendTooltip}
      baselineValue={initialValue}
      icon={icon}
    />
  );
};
